import tracking from '../../utils/tracking';
import OriginTracing from "@atlassiansox/origin-tracing";
import { hamletUser, ProductKeys } from "../../common/hamlet/hamlet-user";
import BasePaths from "../../buyer-experience/common/base-paths";
import Environment from "../../common/environment";
import storage from "../../utils/storage";

import algoliasearch from 'algoliasearch';
import algoliasearchhelper, { AlgoliaSearchHelper } from 'algoliasearch-helper';
import insights from 'search-insights';

import { trackEvent } from "../../common/analytics";

import imkt from "../../imkt";

const ALGOLIA_APP_ID = 'CU5KFWE75C';
const ALGOLIA_SEARCH_API_KEY = '8cb0497a0549da256319b1b8178e5421';
const ALGOLIA_SEARCH_INDEX_NAME = (Environment.getEnvironment() === "production") ? "www.atlassian.com.v3" : "www.atlassian.com.v3_dev";
const ALGOLIA_FACET_KEY = 'category';
const algoliaSearchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_API_KEY);
const locale = Environment.getInternationalSubdirectory() || 'en';
// Initialize Algolia Insights
insights('init', {
  appId: ALGOLIA_APP_ID,
  apiKey: ALGOLIA_SEARCH_API_KEY
});

function sendClickEvent(queryId: string, objectId: string, position: number, searchIndex: string) {
  insights('clickedObjectIDsAfterSearch', {
    eventName: 'Result Clicked (global nav)',
    objectIDs: [objectId],
    positions: [Number(position)],
    queryID: queryId,
    index: searchIndex,
  });
}

const graphqlUrl = `${Environment.getAPIPrivateURL()}/graphql`;
const AVATAR_IMG_URL =
  "http://wac-cdn.atlassian.com/dam/wac/icons/ADG3-Icons-36px-N700/object-avatar-man.svg";


type availableProductsSites = {
  adminAccess: boolean;
  cloudId: string;
  displayName: string;
  edition: string;
  entitlements: any[];
  orgId: string;
  products: string[];
  productsAndEditions: any[];
  url: string;
}

type productMetaData = {
  imgSource: string;
  heading: string;
  subText: string;
  href: string;
}

type productDisplayMetaDataMapType = {
  [key: string]: productMetaData
}

type siteGrowthUnifiedProfileGetUnifiedProfileSiteType = {
  cloudId: string;
  displayName: string;
  siteCreatedAt: string;
  url?: string;
  hasAdminAccess: boolean;
  products: siteGrowthUnifiedProfileGetUnifiedProfileSitesProductType[];
};

type siteGrowthUnifiedProfileGetUnifiedProfileSitesProductType = {
  productName: string;
  productKey:  string;
  productEdition?:  string;
  d0Eligible: boolean;
  d1to6Eligible: boolean;
  d0Active: boolean;
  d1to6Active: boolean;
}




export default class ADG4GlobalNav {
  domRoot: HTMLElement;
  params: any;
  userInfo: any;
  isLoading: boolean;
  basePaths: any;
  origin: any;
  labels: any;
  navType: string;
  ctaLabel?: string;
  defaultTrackProperties: any;
  CloseAll: HTMLElement;
  AccountSignIn: HTMLElement;
  AccountAvatar: HTMLElement;
  AccountInfo: HTMLElement;
  OutlineElement: HTMLElement;
  OverlayColor: HTMLElement;
  OverlayClickable: HTMLElement;
  GenericNavLinks: HTMLElement[];
  DropdownNavLinks: HTMLElement[];
  DropdownNavLinkButtons: HTMLElement[];
  NavLinkButtons: HTMLElement[];
  DropdownContents: HTMLElement[];
  TabButtons: HTMLElement[];
  NavContainingElement: HTMLElement;
  MobileToggle: HTMLElement;
  MobileBackButtons: HTMLElement[];
  MenuMore: HTMLElement;
  MenuLess: HTMLElement;
  SearchOpen: HTMLElement;
  SearchClose: HTMLElement;
  SearchForm: HTMLElement;
  SearchInput: HTMLInputElement;
  SearchInputSVG: HTMLElement;
  SearchResultsContainer: HTMLElement;
  searchHelper: AlgoliaSearchHelper;
  SearchHits: any;
  SearchQuery: string;
  QueryId: string;
  WrappedElementIndex: number;
  WindowWidth: number;
  ButtonMenuMore: HTMLElement;
  ButtonMenuLess: HTMLElement;
  isShowCTADropdown: boolean;
  jiraProductMetaData: productMetaData;
  jiraServiceManagementProductMetaData: productMetaData;
  confluenceProductMetaData: productMetaData;
  jiraProductDiscoveryMetaData: productMetaData;
  compassProductMetaData: productMetaData;
  defaultCtaDesktopButton: HTMLElement;
  cTADropdown: HTMLElement;
  cTADropdownHoverContent: HTMLElement;
  dropdownContentLoader: HTMLElement;
  dropdownPanelContent: HTMLElement;
  isGupsCalled: boolean;
  isHovered: boolean;

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = domRoot;
    this.params = { ...params };
    this.userInfo = {};
    this.isLoading = false;
    this.basePaths = new BasePaths();
    this.origin = new OriginTracing({ product: "wac-globaldropdown" });
    this.labels = params.labels;
    this.navType = params.navType;
    this.ctaLabel = params.ctaLabel;
    this.defaultTrackProperties = {};
    this.CloseAll = domRoot.querySelector(".close-all");
    this.AccountSignIn = domRoot.querySelector(".adg4-nav-account-sign-in");
    this.AccountAvatar = domRoot.querySelector(".adg4-nav-account-logged-in");
    this.AccountInfo = domRoot.querySelector(".adg4-nav-account-info");
    this.OutlineElement = domRoot.querySelector(".outline-element");
    this.OverlayColor = domRoot.querySelector(".overlay-color");
    this.OverlayClickable = domRoot.querySelector(".overlay-clickable");
    this.GenericNavLinks = domRoot.querySelectorAll(".nav-link");
    this.DropdownNavLinks = domRoot.querySelectorAll(".nav-link.has-dropdown");
    this.NavLinkButtons = domRoot.querySelectorAll(".nav-link-button");
    this.TabButtons = domRoot.querySelectorAll(".tab-button");
    this.DropdownContents = domRoot.querySelectorAll(".dropdown-content");
    this.MobileToggle = domRoot.querySelector(".mobile-toggle");
    this.NavContainingElement = domRoot.querySelector(".nav-right-space");
    this.MobileBackButtons = domRoot.querySelectorAll(".mobile-back-button");
    this.MenuMore = domRoot.querySelector(".menu-more");
    this.MenuLess = domRoot.querySelector(".menu-less");
    this.SearchOpen = domRoot.querySelector(".search-open");
    this.SearchClose = domRoot.querySelector(".search-close");
    this.SearchForm = domRoot.querySelector(".search-form");
    this.SearchResultsContainer = domRoot.querySelector(".adg4-search-results");
    this.SearchInput = domRoot.querySelector(".adg4-search-input");
    this.SearchInputSVG = domRoot.querySelector(".input-container svg");
    this.SearchHits = [];
    this.SearchQuery = '';
    this.QueryId = '';
    this.searchHelper = algoliasearchhelper(algoliaSearchClient, ALGOLIA_SEARCH_INDEX_NAME, {
      facetFilters: [`locale:${locale}`],
      facets: [ALGOLIA_FACET_KEY],
      clickAnalytics: true // enables click analytics
    });

    this.WindowWidth = 0;
    this.WrappedElementIndex = '';
    this.ButtonMenuMore = domRoot.querySelector(".button-menu-more");
    this.ButtonMenuLess = domRoot.querySelector(".button-menu-less");

    this.isShowCTADropdown = (params.isShowCTADropdown as string) == "true";
    this.jiraProductMetaData = params.jiraProduct;
    this.jiraServiceManagementProductMetaData = params.jiraServiceManagementProduct;
    this.confluenceProductMetaData = params.confluenceProduct;
    this.jiraProductDiscoveryMetaData = params.jiraProductDiscovery;
    this.compassProductMetaData = params.compassProduct;

    this.defaultCtaDesktopButton = domRoot.querySelector(".cta-desktop#cta-desktop-default") as HTMLElement;
    this.cTADropdown = domRoot.querySelector(".cta-desktop#cta-desktop-dropdown-button") as HTMLElement;
    this.cTADropdownHoverContent = domRoot.querySelector(".cta-dropdown-content#try-now-cta-link-desktop-dropdown") as HTMLElement;

    this.dropdownContentLoader = domRoot.querySelector(".dropdown-content-loader") as HTMLElement;
    this.dropdownPanelContent = domRoot.querySelector(".dropdown-content-panel") as HTMLElement;
    this.isGupsCalled = false;
    this.isHovered = false;

    this.init();
  }

  async init() {
    this.bindEvents();

    if (this.navType !== "subNav" && storage.getCookie("login_user_detected") === "true") {
      this.getUser()
        .then(user => {
          this.isLoading = false;
          this.userInfo = user;
          if (user.isLoggedIn && this.userInfo.displayName.length) {
            tracking.trackEvent("bxp.globalnavdropdown.user.loggedin");
            this.populateLoggedInUser();
          } else {
            this.populateLoggedOutUser();
          }
        })
        .catch(() => {
          tracking.trackEvent(
            "bxp.globalnavdropdown.user.getusererror"
          );
        });
    } else if (this.navType !== "subNav") {
      this.isLoading = false;
      this.populateLoggedOutUser();
    }

    this.addAvatarOutsideClickEventListener();

    await this.onDisplayDropdownButton();
    await this.featureGateConfluenceTemplatesDxpMigration();
  }

  featureGateConfluenceTemplatesDxpMigration = async () => {
    const isConfluenceTemplatesDxpMigration = await imkt.utils.featureGate.checkGate("confluence-templates-dxp-migration");
    const controls = document.querySelectorAll(".exp-control--confluence-templates-dxp-migration");
    const treatments = document.querySelectorAll('.exp-treatment--confluence-templates-dxp-migration');
    
    if (isConfluenceTemplatesDxpMigration) {
      (controls).forEach((nav) => {
        nav.classList.add('link-hidden');
      });
      (treatments).forEach((nav) => {
        nav.classList.remove('link-hidden');
      });
    } else {
      (controls).forEach((nav) => {
        nav.classList.remove('link-hidden');
      });
      (treatments).forEach((nav) => {
        nav.classList.add('link-hidden');
      });
    }
    this.resizeMenus();
  }

  // Get it free CTA dropdown =======================================================================================
  onDisplayDropdownButton = async () => {
    if (this.isShowCTADropdown) {
      this.cTADropdown?.addEventListener('click', async () => {
        this.closeEverything();
        if (this.cTADropdown.classList.contains("open-dropdown")) {
          this.cTADropdown.classList.remove("open-dropdown")
          this.onCloseDisplayDropdownPanelContent();
          this.isHovered = false;
        } else {
          this.cTADropdown.classList.add("open-dropdown")

          if(!this.isGupsCalled) {
            await this.onRenderCTADropdownDisplayContent();
          } else {
            this.onDisplayDropdownPanelContent();
          }
        }
        if(!this.isHovered) {
          trackEvent("button clicked", {
            eventComponent: "button",
            action: "clicked",
            component: "cta-desktop",
            source: "globalNav",
            actionSubjectId: "globalNavCtaDropdownButtonClicked"
          });
        }
      });

      this.cTADropdown?.addEventListener('mouseenter', async () => {
        this.isHovered = true;
        this.cTADropdown.click();

        if (typeof ace !== "undefined") {

          ace.analytics.GASv3.sendTrackEvent(
            'exposed',
            'feature', 
            'gwp-3947-try-now-cta-dropdown', 
            {
              eventContainer: 'gwp-3947-try-now-cta-dropdown',
              group: 'Test'
            },
            false);
        }

        trackEvent("button hovered", {
          eventComponent: "button",
          action: "hovered",
          component: "cta-desktop",
          source: "globalNav",
          actionSubjectId: "globalNavCtaDropdownButtonHovered"
        });
      });

      this.cTADropdown?.addEventListener('mouseleave', () => {
        if (this.cTADropdown.classList.contains("open-dropdown")) {
          this.cTADropdown.classList.remove("open-dropdown");
        }
        this.isHovered = false;
        this.onCloseDisplayDropdownPanelContent();
      });

      if (this.defaultCtaDesktopButton?.classList.contains("show-cta")) {
        this.defaultCtaDesktopButton.classList.remove("show-cta")
      }
      this.cTADropdown.classList.add("show-cta");

    } else {
      if (this.cTADropdown?.classList.contains("show-cta")) {
        this.cTADropdown.classList.remove("show-cta")
      }
      this.defaultCtaDesktopButton?.classList.add("show-cta");
    }

    this.resizeMenus();
  }

  onRenderCTADropdownDisplayContent = async () => {
    const productDisplayHirachy = [
      ProductKeys.JIRA_SOFTWARE,
      ProductKeys.JIRA_SERVICE_MANAGEMENT,
      ProductKeys.CONFLUENCE,
      ProductKeys.JIRA_PRODUCT_DISCOVERY,
      ProductKeys.COMPASS
    ];

    const productDisplayMetaDataMap: productDisplayMetaDataMapType = {
      [ProductKeys.JIRA_SOFTWARE]: this.jiraProductMetaData,
      [ProductKeys.JIRA_SERVICE_MANAGEMENT]: this.jiraServiceManagementProductMetaData,
      [ProductKeys.CONFLUENCE]: this.confluenceProductMetaData,
      [ProductKeys.JIRA_PRODUCT_DISCOVERY]: this.jiraProductDiscoveryMetaData,
      [ProductKeys.COMPASS]: this.compassProductMetaData
    };

    let getFilteredHirachyList = [...productDisplayHirachy];
      try {
        const userOwnedProducts = this.userInfo.isLoggedIn
          ? await this.getUserProductsViaGUPS(productDisplayHirachy)
          : await this.getUserProductsViaGupsWithAnonymousId();
        
        // If the user owns any products, the code filters out these products from the productDisplayHirachy array and updates getFilteredHirachyList accordingly.
        if(userOwnedProducts && userOwnedProducts.length > 0) {
          getFilteredHirachyList = productDisplayHirachy
            .filter(hirachyItem => !userOwnedProducts.includes(hirachyItem))
        }
      } catch (error) {
        console.error(error);
      }

      this.isGupsCalled = true;

      if (getFilteredHirachyList.length < 3) {
        const additionalDisplayNeeded = 3 - getFilteredHirachyList.length;
        // Find additional products from productDisplayHirachy that are not already in getFilteredHirachyList
        const additionalProducts = productDisplayHirachy
          .filter(product => 
            !getFilteredHirachyList.includes(product)
          )
          .slice(0, additionalDisplayNeeded);        
        getFilteredHirachyList = getFilteredHirachyList.concat(additionalProducts);
      } else {
        getFilteredHirachyList = getFilteredHirachyList.slice(0, 3);
      }

      this.cTADropdownHoverContent.querySelector("#highlightItem1__link")!.setAttribute("href", productDisplayMetaDataMap[getFilteredHirachyList[0]].href);
      this.cTADropdownHoverContent.querySelector("#highlightItem1__img")!.setAttribute("src", productDisplayMetaDataMap[getFilteredHirachyList[0]].imgSource);
      this.cTADropdownHoverContent.querySelector("#highlightItem1__product--title")!.innerHTML = productDisplayMetaDataMap[getFilteredHirachyList[0]].heading;
      this.cTADropdownHoverContent.querySelector("#highlightItem1__product--subText")!.innerHTML = productDisplayMetaDataMap[getFilteredHirachyList[0]].subText;

      this.cTADropdownHoverContent.querySelector("#highlightItem2__link")!.setAttribute("href", productDisplayMetaDataMap[getFilteredHirachyList[1]].href);
      this.cTADropdownHoverContent.querySelector("#highlightItem2__img")!.setAttribute("src", productDisplayMetaDataMap[getFilteredHirachyList[1]].imgSource);
      this.cTADropdownHoverContent.querySelector("#highlightItem2__product--title")!.innerHTML = productDisplayMetaDataMap[getFilteredHirachyList[1]].heading;
      this.cTADropdownHoverContent.querySelector("#highlightItem2__product--subText")!.innerHTML = productDisplayMetaDataMap[getFilteredHirachyList[1]].subText;

      this.cTADropdownHoverContent.querySelector("#highlightItem3__link")!.setAttribute("href", productDisplayMetaDataMap[getFilteredHirachyList[2]].href);
      this.cTADropdownHoverContent.querySelector("#highlightItem3__img")!.setAttribute("src", productDisplayMetaDataMap[getFilteredHirachyList[2]].imgSource);
      this.cTADropdownHoverContent.querySelector("#highlightItem3__product--title")!.innerHTML = productDisplayMetaDataMap[getFilteredHirachyList[2]].heading;
      this.cTADropdownHoverContent.querySelector("#highlightItem3__product--subText")!.innerHTML = productDisplayMetaDataMap[getFilteredHirachyList[2]].subText;

      this.onDisplayDropdownPanelContent();
  };

  onDisplayDropdownPanelContent = () => {
    if(!this.dropdownContentLoader.classList.contains("hide")) {
      this.dropdownContentLoader.classList.add("hide");
    }
    if(!this.dropdownPanelContent.classList.contains("active")) {
      this.dropdownPanelContent.classList.add("active");
    }
  }

  onCloseDisplayDropdownPanelContent = () => {
    if(this.dropdownContentLoader.classList.contains("hide")) {
      this.dropdownContentLoader.classList.remove("hide");
    }
    if(this.dropdownPanelContent.classList.contains("active")) {
      this.dropdownPanelContent.classList.remove("active");
    }
  }

  async onGraphqlApiRequest(query: string): Promise<Response> {
    return fetch(graphqlUrl, {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-type": "application/json",
        },
        body: JSON.stringify({ query: query })
    });
  }

  getUserProductsViaGupsWithAnonymousId = async () => {
    const productDisplayHirachyByNameMap = {
      'jira': ProductKeys.JIRA_SOFTWARE, 
      'confluence': ProductKeys.CONFLUENCE, 
      'jsm': ProductKeys.JIRA_SERVICE_MANAGEMENT, 
      'jpd': ProductKeys.JIRA_PRODUCT_DISCOVERY,
      'compass': ProductKeys.COMPASS
    };

    const cleanAnonymousId = decodeURIComponent(storage.getCookie("ajs_anonymous_id") ?? "").replace(/['"]+/g, "");
    const queryWithAnonymousId = `
      query getUnifiedProfile {
          growthUnifiedProfile_getUnifiedProfile(
              anonymousId: "${cleanAnonymousId}"
          ) {
              entityType
              enrichmentStatus
              userFootprints {
                products
                hasAtlassianAccount
              }
          }
      }
    `;

    const response = await this.onGraphqlApiRequest(queryWithAnonymousId);
    if(response.ok) {
      const responseJson = await response.json();
      const userFootprints = responseJson.data.growthUnifiedProfile_getUnifiedProfile.userFootprints.products;
      if (userFootprints.length > 0) {
        const mappedUserFootPrints = (userFootprints as (keyof typeof productDisplayHirachyByNameMap)[]).map((userFootprints) => productDisplayHirachyByNameMap[userFootprints]);
        return mappedUserFootPrints;
      }
      return userFootprints;
    }
    throw 'Unable to fetch userFootprints products';
  };

  getUserProductsViaGUPS = async (productDisplayHirachy) => {
    // Map productDisplay to metadata from param
    const userAaid = await hamletUser.getUserAaid();
    const query = ` 
        query getProfile {
          growthUnifiedProfile_getUnifiedProfile(
            accountId: "${userAaid}"
          ) {
            sites {
              cloudId
              displayName
              siteCreatedAt
              url
              hasAdminAccess
              products {
                productName
                productKey
                productEdition
                d0Eligible
                d1to6Eligible
                d0Active
                d1to6Active
                
              }
            } 
          }
        }
    `;

    const response = await this.onGraphqlApiRequest(query);
    if(response.ok) {
      const responseJson = await response.json();
      const siteProductList = (
          responseJson
            .data
            .growthUnifiedProfile_getUnifiedProfile
            .sites as siteGrowthUnifiedProfileGetUnifiedProfileSiteType[]
          ).flatMap(site => {
            return site.products.map(product => product.productKey);
          });
      if (siteProductList.length > 0) {
        const ownedProductList = productDisplayHirachy.filter((productKey: string) => 
            siteProductList.includes(productKey)
          );
        return ownedProductList;
      }
      return siteProductList;
    }
    throw 'Unable to fetch user products';
  }
  
  
  // =======================================================================================

  bindEvents = () => {
    if (this.navType! == "subNav") {
      document.body.classList.add('compound-nav');
      this.scrollPositioning();
      document.addEventListener("scroll", () => {
        this.scrollPositioning();
      });
    }
    this.resizeMenus();

    window.addEventListener("resize", () => {
      this.resizeMenus();
      this.scrollPositioning();
    });

    [...this.DropdownNavLinks].forEach(dropdownNavLink => {
      dropdownNavLink.addEventListener("mouseenter", () => {
        if (document.documentElement.clientWidth > 1024) {
          this.unFocusNavs();
          dropdownNavLink.classList.remove("clicked-hide");
          this.AccountAvatar?.classList.remove("show-menu");
          let navDropdownContent: HTMLElement = dropdownNavLink.querySelector(".dropdown-content");
          let navDropdownContentSizer: HTMLElement = dropdownNavLink.querySelector(".dropdown-content-inner");
          this.outlineElementSizer(navDropdownContentSizer, navDropdownContent);
        }

      });
    });

    [...this.NavLinkButtons].forEach(navLinkButton => {
      navLinkButton.addEventListener("click", () => {
        this.domRoot.classList.add("secondary-show");
        const navLinkId = navLinkButton.dataset.navlinkid;
        let navDropdownContent = this.domRoot.querySelector("#" + navLinkId);

        let tabId;
        if (navLinkButton.dataset.tabid) {
          tabId = navLinkButton.dataset.tabid;
          const matchingTab: HTMLElement = navDropdownContent?.querySelector('#' + tabId);
          const tabs: HTMLElement[] = navDropdownContent?.querySelectorAll('.singular-tab-content');
          [...tabs].forEach(tab => {
            tab.classList.remove("active")
          });
          matchingTab?.classList.add("active");
        }

        [...this.DropdownContents].forEach(dropdownContent => {
          dropdownContent.classList.remove("mobile-show");
        });
        navDropdownContent?.classList.add("mobile-show");
        navLinkButton.parentNode.classList.toggle("clicked-hide");
      });

      // keyboard navigation
      navLinkButton.addEventListener("keyup", (e: any) => {
        const buttonLi = navLinkButton.parentNode;
        if (e.key == "Tab" && document.documentElement.clientWidth > 1024) {
          this.unFocusNavs();
          buttonLi.classList.add("key-focus");

          this.AccountAvatar?.classList.remove("show-menu");
          if (buttonLi.classList.contains("has-dropdown")) {
            let navDropdownContent: HTMLElement = buttonLi.querySelector(".dropdown-content");
            let navDropdownContentSizer: HTMLElement = buttonLi.querySelector(".dropdown-content-inner");
            this.outlineElementSizer(navDropdownContentSizer, navDropdownContent);
          }
        } else if (e.key == "Enter") {
          let finder = buttonLi;
          let tabId = navLinkButton.getAttribute("data-tabid");
          if (tabId && document.getElementById(tabId)) {
            finder = document.getElementById(tabId);
          }
          const firstLink: HTMLElement = finder.querySelector(".tab-content-area a");
          firstLink.focus({ focusVisible: true });
        } else if (e.key == "Escape") {
          this.closeEverything();
        }

      });
    });

    [...this.TabButtons].forEach(tabButton => {

      tabButton.addEventListener("click", () => {
        const tabsParent: HTMLElement = tabButton.closest(".dropdown-content");
        const tabsParentInner: HTMLElement = tabsParent.querySelector(".dropdown-content-inner");

        const thisTabID = tabButton.dataset.tabid;
        const multiTabContents: HTMLElement[] = tabsParent.querySelectorAll(".singular-tab-content");
        const multiTabButtons: HTMLElement[] = tabsParent.querySelectorAll(".tab-button");

        [...multiTabButtons].forEach(tabButton => {
          tabButton.classList.remove("active");
        });

        [...multiTabContents].forEach(tabContent => {
          if (tabContent.id == thisTabID) {
            tabContent.classList.add("active")
          } else {
            tabContent.classList.remove("active");
          }
        });
        tabButton.classList.add("active");
        this.outlineElementSizer(tabsParentInner, tabsParent);

      })
    });

    this.ButtonMenuMore.addEventListener("click", () => {
      this.domRoot.classList.add("menu-expanded");
    });

    this.ButtonMenuLess.addEventListener("click", () => {
      this.domRoot.classList.remove("menu-expanded");
    });

    this.CloseAll.addEventListener("click", () => {
      this.closeEverything();
    });

    this.MobileToggle.addEventListener("click", () => {
      this.AccountAvatar?.classList.remove("show-menu");
      this.domRoot.classList.remove("secondary-show");
      if (this.domRoot.classList.contains("mobile-show")) {
        this.domRoot.classList.remove("mobile-show");
        this.hideClickableOverlay();
      } else {
        this.domRoot.classList.add("mobile-show");
        this.showClickableOverlay();
      }

    });

    [...this.MobileBackButtons].forEach(mobileBackButton => {
      mobileBackButton.addEventListener("click", () => {
        this.domRoot.classList.remove("secondary-show");
        this.SearchForm?.classList.remove("active");
        setTimeout(() => {
          this.SearchForm.style.overflow = "hidden";
          mobileBackButton.parentNode.classList.remove("mobile-show");
        }, 250);
      });
    });

    if (this.navType !== "subNav") {
      this.SearchOpen.addEventListener("click", async () => {
        this.showClickableOverlay();
        this.SearchForm.classList.add("active");
        this.closeReturnToProductModal();
        setTimeout(() => {
          this.SearchForm.style.overflow = "visible";
          const SigninPromptDropdownMenu = document.querySelector(".signin-prompt-dropdown-menu-wrapper");
          if (SigninPromptDropdownMenu && !(SigninPromptDropdownMenu as HTMLElement).classList.contains("hidden")) {
            (SigninPromptDropdownMenu as HTMLElement).classList.add("hidden");
          }
        }, 250);
        this.domRoot.classList.add("secondary-show");

        trackEvent("button clicked searchButtonDesktop", {
          eventComponent: "button",
          action: "clicked",
          component: "button",
          source: "globalNav",
          actionSubjectId: "searchButtonDesktop"
        });

        if (typeof ace !== "undefined") {
          // Send attribution exposure for search index v3 experiment
          ace.analytics.GASv3.sendTrackEvent(
            'exposed',
            'feature', 
            'wac-search-indexv3', 
            {
              eventContainer: 'wac-search-indexv3',
              group: 'Test'
            },
            false);
        }
      });

      this.SearchClose.addEventListener("click", () => {
        this.closeSearch();
        this.domRoot.classList.remove("secondary-show");
        this.ReturnToProductModal?.classList.remove('close');
        this.ReturnToProductModal?.classList.add('open');

        trackEvent("button clicked searchCloseButtonDesktop", {
          eventComponent: "button",
          action: "clicked",
          component: "button",
          source: "globalNav",
          actionSubjectId: "searchCloseButtonDesktop"
        });
      });


      this.searchHelper.on('result', ({ results, state }) => {
        if (results && results.hits) {
          this.SearchHits = results.hits;
          this.SearchQuery = results.query;
          this.QueryId = results.queryID as string;
        }
      });

      this.SearchInput.addEventListener("keyup", (e) => {
        this.searchHelper.setQuery(e.target.value);
        this.searchHelper.search();

        this.populateSearchResults();
      });

      this.SearchInput.addEventListener("keypress", (e) => {
        if (e.key === 'Enter') {
          trackEvent("search submitted", {
            eventComponent: "search",
            action: "submitted",
            component: "searchInput",
            source: "globalNav",
            actionSubjectId: "globalNavSearchBar"
          });

          window.location.href = `/search?q=${e.target.value}`;
        }
      });

      this.SearchInputSVG.addEventListener('click', function () {
        var searchInput = document.querySelector(".adg4-search-input") as HTMLInputElement;
        window.location.href = `/search?q=${searchInput?.value}`;
      });
    }
  }

  closeEverything = () => {
    this.hideClickableOverlay();
    this.unFocusNavs();
    this.AccountAvatar?.classList.remove("show-menu");
    this.closeSearch();
  }

  openReturnToProductModal = () => {
    const modalElement = document.querySelector('.return-to-product-modal');
    if (modalElement) {
      modalElement.classList.remove('close');
      modalElement.classList.add('open');
    } 
  }

  closeReturnToProductModal = () => {
    const modalElement = document.querySelector('.return-to-product-modal');
    if (modalElement) {
      modalElement.classList.remove('open');
      modalElement.classList.add('close');
    } 
  }

  resizeMenus = () => {
    if (document.documentElement.clientWidth > 1024 && !this.domRoot.classList.contains("menu-expanded")) {
      let hasWrapped = false;
      let firstWrapped = 0;
      for (let i = 0; i < [...this.GenericNavLinks].length; i++) {
        const navLink = [...this.GenericNavLinks][i];
        if (navLink.offsetTop > 0 || (navLink.nextElementSibling.offsetTop > 0)) {
          navLink.classList.add("wrapped");
          if (!hasWrapped) {
            hasWrapped = true;
            firstWrapped = i;
          }
        } else if (
          (this.WindowWidth > document.documentElement.clientWidth && this.WrappedElementIndex > i)
          ||
          (this.WindowWidth < document.documentElement.clientWidth && this.WrappedElementIndex < i)
        ) {
          navLink.classList.remove("wrapped");
        }
      };

      this.WrappedElementIndex = firstWrapped;
      this.WindowWidth = document.documentElement.clientWidth;

      if (hasWrapped) {
        this.domRoot.classList.add("menu-wrapped");

      } else {
        this.domRoot.classList.remove("menu-wrapped");

      }
    }
  }

  scrollPositioning = () => {
    if (document.documentElement.clientWidth > 1024 && window.scrollY > 68) {
      document.body.classList.add("compound-stuck");
    } else {
      document.body.classList.remove("compound-stuck");
    }
  }

  outlineElementSizer = (comparisonElement: HTMLElement, comparisonParent: HTMLElement) => {
    this.OutlineElement.style.width = (comparisonElement.offsetWidth) + "px";
    this.OutlineElement.style.height = (comparisonElement.offsetHeight) + "px";
    this.OutlineElement.style.left = (comparisonParent.offsetLeft) + "px";
  }

  showClickableOverlay = () => {
    this.OverlayClickable.classList.add("mobile-show");
    this.OverlayColor.classList.add("mobile-show");
  }

  hideClickableOverlay = () => {
    this.domRoot.classList.remove("mobile-show");
    this.domRoot.classList.remove("secondary-show");
    this.OverlayColor.classList.remove("mobile-show")
    this.OverlayClickable.classList.remove("mobile-show");
  }

  unFocusNavs = () => {
    [...this.NavLinkButtons].forEach(otherDropdownLink => {
      otherDropdownLink.parentNode.classList.remove("key-focus", "clicked-hide");
    });
  }

  closeSearch = () => {
    this.hideClickableOverlay();
    this.openReturnToProductModal();
    if (this.navType !== "subNav") {
      this.SearchForm.style.left = "100%";
      this.SearchResultsContainer.innerHTML = '';
      this.SearchInput.value = '';
      setTimeout(() => {
        this.SearchForm.classList.remove("active");
        this.SearchForm.style.left = '';
        const SigninPromptDropdownMenu = document.querySelector(".signin-prompt-dropdown-menu-wrapper");
        if (SigninPromptDropdownMenu && (SigninPromptDropdownMenu as HTMLElement).classList.contains("hidden")) {
          (SigninPromptDropdownMenu as HTMLElement).classList.remove("hidden");
        }

      }, 250);
    }

  }

  hideUserMenu = () => {
    this.hideClickableOverlay();
    this.AccountAvatar?.classList.remove("show-menu");
    this.openReturnToProductModal();
  }

  showUserMenu = () => {
    this.showClickableOverlay();
    this.AccountAvatar?.classList.add("show-menu");
    this.closeReturnToProductModal();
  }

  createEl = (info: any) => {
    const newEl = document.createElement(info.tag);
    newEl.innerHTML = info.label;
    newEl.onclick = info.clicker;
    newEl.className = info.classes ? info.classes : '';
    return newEl;
  }

  populateLoggedInUser = () => {
    document.querySelector("#adg4-app-switcher")?.classList.add("loaded");
    const userProfileMenu = this.createEl({
      tag: "div",
      classes: "user-profile-info",
      label: `<span>${this.userInfo.email}</span>`
    });

    const ProfileButtons = [
      this.createEl({ tag: "button", label: this.labels["JoinSiteUserDropdown.switchAccount"], clicker: () => { this.onSwitchAccountClick() } }),
      this.createEl({ tag: "button", label: this.labels["JoinSiteUserDropdown.profile"], clicker: () => { this.onManageProfileClick() } }),
      this.createEl({ tag: "button", label: this.labels["JoinSiteUserDropdown.licenses"], clicker: () => { this.onManageLicensesClick() } }),
      this.createEl({ tag: "button", label: this.labels["JoinSiteUserDropdown.logOut"], clicker: () => { this.onLogOutClick() } })
    ];
    ProfileButtons.forEach(btn => {
      userProfileMenu.appendChild(btn);
    })

    const userButton = this.createEl({
      tag: "button",
      classes: "account",
      label: `<img src="${this.userInfo.avatar}"><span id="account-login-fullname">${this.userInfo.displayName.slice(0, 15)}${this.userInfo.displayName.length > 14 ? "..." : ""}</span>`,
      clicker: (event: MouseEvent) => {
        event.stopPropagation(); // Prevent the event from propagating
        if (this.AccountAvatar?.classList.contains("show-menu")) {
          this.hideUserMenu();
        } else {
          this.showUserMenu();
        }
      }
    });

    this.AccountAvatar?.appendChild(userButton);
    this.AccountAvatar?.appendChild(userProfileMenu);
    this.resizeMenus();
  }

  handelOffElementDropdownClickEvent = (event: MouseEvent) => {
    if (!(event.target as HTMLElement).closest(".user-profile-info")
      && this.AccountAvatar?.classList.contains("show-menu")) {
      clicker: (event: MouseEvent) => {
        event.stopPropagation(); // Prevent the event from propagating
        this.hideUserMenu();
      }
    }
  }

  handelOffElementDropdownEscKeyEvent = (event: KeyboardEvent) => {
    if (event.key === "Escape"
      && this.AccountAvatar?.classList.contains("show-menu")) {
      this.hideUserMenu();
    }
  }

  addAvatarOutsideClickEventListener = () => {
    this.domRoot.addEventListener("mousedown", this.handelOffElementDropdownClickEvent);
    this.domRoot.addEventListener("keydown", this.handelOffElementDropdownEscKeyEvent, false);
  }

  populateLoggedOutUser = () => {
    const loginInButton = this.createEl({
      tag: "button",
      clicker: this.onLogInClick,
      label: this.labels["JoinSiteUserDropdown.logIn"]
    });
    this.AccountSignIn.appendChild(loginInButton);
    this.resizeMenus();
  }

  populateSearchResults = () => {
    this.SearchResultsContainer.innerHTML = '';
    const searchArray = this.SearchHits;
    const query = this.SearchQuery;
    const filteredSearchArray = searchArray.filter((hit: any) => hit.hasOwnProperty("description") && hit.hasOwnProperty("url")).slice(0, 7);
    const ulResults = document.createElement("ul");
    const resultsFragment = document.createDocumentFragment();
    const searchIndex = this.searchHelper.getIndex();

    if (query.length > 0 && filteredSearchArray.length > 0) {
      filteredSearchArray.forEach((hit, index) => {
        const hitLi = document.createElement("li");
        const hitA = document.createElement("a");
        hitA.href = hit.url;
        hitA.onclick = () => {
          tracking.trackEvent("bxp.globalnavdropdown.click.search-result");

          // Send click event to Algolia
          const position = index + 1;
          sendClickEvent(this.QueryId, hit.objectID, position, searchIndex);

          trackEvent("linkButton clicked", {
            eventComponent: "linkButton",
            action: "clicked",
            component: "searchResult",
            source: "globalNav",
            actionSubjectId: "globalNavSearchResults"
          });
        };
        const searchHitTitle = hit.title;
        const lowCaseSearch = query.toLowerCase();
        const lowCaseTitle = searchHitTitle.toLowerCase();
        const splitter = new RegExp(`${lowCaseSearch}(.*)`, "s");
        const [split1, split2] =
          lowCaseTitle.split(splitter) as [
            string,
            string
          ];
        const displayTitle = `${searchHitTitle.slice(0, split1.length)}<strong>${lowCaseTitle.includes(query) ? query : ''}</strong>${searchHitTitle.slice(split1.length + lowCaseSearch.length, split1.length + lowCaseSearch.length + (split2 ? split2.length : searchHitTitle.length))}`;
        hitA.innerHTML = displayTitle;
        hitLi.appendChild(hitA);
        resultsFragment.appendChild(hitLi);
      });

      ulResults.appendChild(resultsFragment);
      this.SearchResultsContainer.appendChild(ulResults);
    } else if (query.length > 0 && filteredSearchArray.length == 0) {
      ulResults.innerHTML = "No results found";

      ulResults.appendChild(resultsFragment);
      this.SearchResultsContainer.appendChild(ulResults);
    } else if (query.length < 1) {
      this.SearchResultsContainer.innerHTML = "";
    }
  }

  sendTracking(eventName: string, linkName: string) {
    var properties = {
      originUrl: window.location.href,
      linkText: linkName,
    };
    tracking.trackEvent(eventName, properties);
  }

  /* account */

  onSwitchAccountClick = () => {
    tracking.trackEvent("bxp.globalnavdropdown.click.switchAccount");
    window.location.href = Environment.getSwitchAccountURL();
  }

  onManageProfileClick = () => {
    const additionalTracking = {
      label: this.labels["JoinSiteUserDropdown.profile"]
    };
    tracking.trackEvent(
      "bxp.globalnavdropdown.click.manage.profile",
      Object.assign(this.defaultTrackProperties, {
        ...additionalTracking,
        ...this.origin.toAnalyticsAttributes({ hasGeneratedId: true })
      })
    );
    window.location.href = Environment.getManageProfileUrl(this.userInfo.email);
  }

  onManageLicensesClick = () => {
    const additionalTracking = {
      label: this.labels["JoinSiteUserDropdown.licenses"]
    };
    tracking.trackEvent(
      "bxp.globalnavdropdown.click.manage.licenses",
      Object.assign(this.defaultTrackProperties, {
        ...additionalTracking,
        ...this.origin.toAnalyticsAttributes({ hasGeneratedId: true })
      })
    );
    window.location.href = Environment.getMacUrl();
  }

  onLogOutClick = () => {
    const additionalTracking = {
      label: this.labels["JoinSiteUserDropdown.logOut"]
    };
    tracking.trackEvent(
      "bxp.globalnavdropdown.click.logout",
      Object.assign(this.defaultTrackProperties, {
        ...additionalTracking,
        ...this.origin.toAnalyticsAttributes({ hasGeneratedId: true })
      })
    );
    window.location.href = Environment.getLogoutUrl();
  }

  onLogInClick = () => {
    const baseUrl = Environment.getIdentityBaseUrl();
    const stargateBaseUrl = Environment.getAPIPrivateURL();
    const continueUrl = this.origin.addToUrl(stargateBaseUrl + "/start/authredirect");
    const additionalTracking = {
      label: this.labels["JoinSiteUserDropdown.logIn"]
    };
    tracking.trackEvent(
      "bxp.globalnavdropdown.click.login",
      Object.assign(this.defaultTrackProperties, {
        ...additionalTracking,
        ...this.origin.toAnalyticsAttributes({ hasGeneratedId: true })
      })
    );
    window.location.href = `${baseUrl}/login?continue=${encodeURIComponent(
      continueUrl
    )}`;
  }

  onJoinYourTeamClick = () => {
    const baseUrl = Environment.getIdentityBaseUrl();
    const stargateBaseUrl = Environment.getAPIPrivateURL();
    const continueUrl = this.origin.addToUrl(stargateBaseUrl + "/start/authredirect");
    const additionalTracking = {
      label: this.labels["JoinSiteUserDropdown.joinTeam"]
    };
    tracking.trackEvent(
      "bxp.globalnavdropdown.click.join.team",
      Object.assign(this.defaultTrackProperties, {
        ...additionalTracking,
        ...this.origin.toAnalyticsAttributes({ hasGeneratedId: true })
      })
    );
    window.location.href = `${baseUrl}/login?continue=${encodeURIComponent(
      continueUrl
    )}`;
  }

  onCreateAcountClick = () => {
    const loginUrl = `${Environment.getIdentityBaseUrl()}/signup?`;
    const startUrl = Environment.getStartUrl();
    const additionalTracking = {
      label: this.labels["JoinSiteUserDropdown.createAccount"]
    };
    tracking.trackEvent(
      "bxp.globalnavdropdown.click.create.account",
      Object.assign(this.defaultTrackProperties, {
        ...additionalTracking,
        ...this.origin.toAnalyticsAttributes({ hasGeneratedId: true })
      })
    );
    window.location.href =
      loginUrl + `&continue=${encodeURIComponent(startUrl)}`;
  }

  async getUser() {
    const isDebugMode = window.location.search.includes("debug=true");

    await hamletUser.getStargateProfile(true, isDebugMode, true);
    const email = hamletUser.getUserEmail() || "";
    return {
      sites: hamletUser.getSites(),
      displayName: hamletUser.getDisplayName(),
      avatar: hamletUser.getAvatar(),
      email,
      isLoggedIn: hamletUser.isLoggedIn()
    };
  }

  async getAvailableProductsAndUserLoggedInStatus() {
    const availableProductsSites = await hamletUser.retrieveAvailableProductsData(false);
    return availableProductsSites;
  }
}
